'use client'
import { ToDateTime, ValueWithUnit } from '@repo/shared/components'
import { MessagesKeys, useTranslate } from '@repo/shared/hooks'
import { UserProject, UserUserAssetTransfer } from '@repo/services'
import {
  AspectRatio,
  Badge,
  Button,
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTrigger,
  Row,
  Typography,
} from '@repo/ui/components'
// import { statusColorMapper, TStatus } from './balance.item'
import { useState } from 'react'
import Image from 'next/image'
import { globalConfig } from '@repo/shared/utils'

interface BalanceProjectTransferDetailsDialogProps {
  data: UserUserAssetTransfer
  children: React.ReactNode
  projectData: UserProject
}

const ImageComp = ({ src, isSquare }: { src?: string; isSquare?: boolean }) => {
  const url = src
    ? `${globalConfig.baseImageUrl}${src}`
    : '/images/placeholder.webp'

  return (
    <div className='w-lg'>
      <AspectRatio className=' aspect-1/1'>
        <Image
          src={isSquare ? '/images/club-gem.svg' : url}
          alt='Photo of property'
          fill
          sizes='(max-width: 768px) 100vw, 32px'
          className='h-full w-full  rounded-2xs object-cover'
          loading='lazy'
        />
      </AspectRatio>
    </div>
  )
}
export const BalanceProjectTransferDetailsDialog = (
  props: BalanceProjectTransferDetailsDialogProps,
) => {
  const { children } = props
  const { createdAt, credit, debit, currency, details } = props.data
  const { t } = useTranslate()

  const [open, setOpen] = useState(false)

  const title =
    debit && debit > 0 ? t('walletPage_debit') : t('walletPage_credit')

  const transferType = (debit || 0) > 0 ? 'debit' : 'credit'

  const description = details?.maskedPeerPhone
    ? details?.maskedPeerPhone?.replace('+98', '0')
    : details?.maskedPeerEmail

  const handleBack = () => {
    setOpen(false)
  }

  // const totalCharges = 0

  // charges?.reduce(
  //   (sum, charge) => sum + (charge.value ?? 0),
  //   0,
  // )

  return (
    <Modal open={open} onOpenChange={setOpen}>
      <ModalTrigger>{children}</ModalTrigger>
      <ModalContent className='sm:max-w-[425px]'>
        <ModalHeader>
          <ModalTitle>
            <Badge
              color={debit && debit > 0 ? 'positive' : 'negative'}
              variant='solid'
            >
              {title}
            </Badge>
          </ModalTitle>
        </ModalHeader>

        <>
          <Row className='justify-center items-center'>
            <Typography size='sm' weight='bold'>
              {props.projectData.displayName}
            </Typography>
          </Row>
          <Row className='justify-between'>
            <Typography className='flex-1'>{t('common_time')}</Typography>
            <Typography className='text-neutral-surface-80' variant='bdi'>
              <ToDateTime date={new Date(createdAt ?? '')} />
            </Typography>
          </Row>
          <Row className='justify-between'>
            <Typography className='flex-1'>{t('common_token')}</Typography>

            <Row className='justify-between w-fit gap-3xs'>
              <Typography
                variant='bdi'
                size='sm'
                className='text-neutral-surface-100  font-[AzarMehr] '
              >
                {currency === 'MALEK' ? 'SQ²' : currency}
              </Typography>
              <ImageComp
                isSquare={currency === 'MALEK'}
                src={
                  currency === 'MALEK'
                    ? '/images/club-gem.svg'
                    : props.projectData?.logoURL
                }
              />
            </Row>
          </Row>

          <Row className='justify-between'>
            <Typography className='flex-1'>{t('common_amount')}</Typography>
            <ValueWithUnit
              value={debit && debit > 0 ? debit : (credit ?? 0)}
              unit={props.projectData.kind}
              scale={props.projectData.scale}
            />
          </Row>
          <Row className='justify-between'>
            <Typography className='flex-1'>
              {' '}
              {t(`transferType_${transferType}` as MessagesKeys)}
            </Typography>
            <bdi className='px-1'>{description}</bdi>
          </Row>

          {/* <Row className='justify-between'>
            <Typography className='flex-1'>
              {t(
                orderType === 'buy'
                  ? 'common_details_fee'
                  : 'common_details_fee',
              )}
            </Typography>
            <ValueWithUnit
              value={totalCharges}
              unit={'TMN'}
              scale={10}
              valueWeight='bold'
            />
          </Row> */}
          {/* <Row className='justify-between'>
            <Typography className='flex-1'>
              {t(
                orderType === 'buy'
                  ? 'common_details_buy_final_amount'
                  : 'common_details_sell_final_amount',
              )}
            </Typography>
            <ValueWithUnit
              value={baseAmount}
              unit={'TMN'}
              scale={10}
              valueWeight='bold'
            />
          </Row> */}
        </>

        <ModalFooter className='flex flex-col gap-md'>
          <Button
            variant='ghost'
            width='full'
            size='md'
            color='neutral'
            onClick={handleBack}
          >
            {t('common_back')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
